import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Detail from './Detail';

export default function PushRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={match.url} component={Detail} />
    </Switch>
  );
}
